import { PureComponent } from "react";

export class Form extends PureComponent {
  render() {
    return <div>This view is no longer supported</div>;
  }
}

export default Form;
